import React, { useState, useEffect, useCallback } from 'react';
import BaseModel from '../../BaseModal';
import { FlexWrapperCenter } from '../../styles/WrapperStyles';
import styled from 'styled-components';
import urls from '../../api/urls.json';
import { authorizedHttpGet } from '../../api/httpCalls';
import './Modal.css';

const ParentDiv = styled.div`
  width: 760px;
  max-height: 450px;
  border-radius: 20px;
  overflow-y: auto;
`;

const TitleView = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 20px;
  font-weight: 800;
  color: #484848;
  text-align: center;
  margin-bottom: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  background-color: #f2f2f2;
  font-family: 'Gilory-Semi';
  font-size: 16px;
  font-weight: 600;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  font-family: 'Gilory-Semi';
  font-size: 16px;
`;

const ErrorText = styled.div`
  color: red;
  padding: 16px;
  text-align: center;
  font-family: 'Gilory-Semi';
`;

const EmptyText = styled.div`
  color: #484848;
  padding: 16px;
  text-align: center;
  font-family: 'Gilory-Semi';
`;

function SparkPurchaseHistoryModal(props) {
    const [data, setData] = useState([]);
    const [error, setError] = useState('');

    const fetchSparkPurchaseHistory = useCallback(async () => {
        try {
            const response = await authorizedHttpGet(urls.GET_SPARK_PURCHASE_HISTORY, { ref: props.userRef });
            if (response.status && response.data) {
                setData(response.data.spark_purchase_history || []);
                setError('');
            } else {
                setData([]);
                setError(response.data?.error || 'Unable to fetch spark purchase history.');
            }
        } catch (err) {
            setData([]);
            setError('Unable to fetch spark purchase history.');
        }
    }, [props.userRef]);

    useEffect(() => {
        if (props.display) {
            fetchSparkPurchaseHistory();
        }
    }, [props.display, fetchSparkPurchaseHistory]);

    return (
        <BaseModel closeModal={props.closeModal}>
            <ParentDiv>
                <FlexWrapperCenter>
                    <TitleView>Spark Purchase History</TitleView>
                </FlexWrapperCenter>
                {error ? (
                    <FlexWrapperCenter>
                        <ErrorText>{error}</ErrorText>
                    </FlexWrapperCenter>
                ) : data.length === 0 ? (
                    <FlexWrapperCenter>
                        <EmptyText>No spark purchase history found.</EmptyText>
                    </FlexWrapperCenter>
                ) : (
                    <Table>
                        <thead>
                            <tr>
                                <Th>Date</Th>
                                <Th>Source</Th>
                                <Th>Total</Th>
                                <Th>Used</Th>
                                <Th>Left</Th>
                                <Th>Expires</Th>
                                <Th>Status</Th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index}>
                                    <Td>{item.datetime}</Td>
                                    <Td>{item.source_type}{item.source_id ? ` #${item.source_id}` : ''}</Td>
                                    <Td>{item.total_count}</Td>
                                    <Td>{item.used_count}</Td>
                                    <Td>{item.left_count}</Td>
                                    <Td>{item.expires_at}</Td>
                                    <Td>{item.status}</Td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </ParentDiv>
        </BaseModel>
    );
}

export default SparkPurchaseHistoryModal;
